export enum PromoCodeDiscountType {
  FLAT_AMOUNT = 1,
  PERCENTAGE = 2,
}
